import _generateUtilityClasses from "@mui/material/generateUtilityClasses";
var checkboxClasses = _generateUtilityClasses('SovosCheckbox', ['focusVisible']);
export default checkboxClasses;